import {Route} from "react-router-dom";
import React from "react";
import CommissionSelectorContainer from "../components/CommissionSelectorContainer";
import CommissionCreationForm from "../components/CommissionCreationForm";
import CommissionDamagesContainer from "../components/damages/CommissionDamagesContainer";


export const COMMISSION_SELECTION_ROUTE =  <Route path="/commissions" exact component={CommissionSelectorContainer}/>;
export const COMMISSION_CREATION_ROUTE =  <Route path="/commissions/create" exact component={CommissionCreationForm}/>;
export const COMMISSION_UPDATION_ROUTE =  <Route path="/commissions/update/:caseId" exact component={CommissionCreationForm}/>;
export const COMMISSION_DAMAGES_ROUTE =  <Route path="/commissions/:commissionId" exact component={CommissionDamagesContainer}/>;


// WEBPACK FOOTER //
// ./src/commissions/routes/routes.js